import { useTranslation } from 'react-i18next';
import logoRounded from '@assets/images/logo-rounded.webp';
import salesNetworkMap from '@assets/images/sales-network-map.svg';
import Collapsible from '@layouts/main-layout/footer/collapsible/Collapsible';
import About from '@layouts/main-layout/footer/footer-menu/About';
import Order from '@layouts/main-layout/footer/footer-menu/Order';
import { useIsSmallScreen } from '@hooks/is-small-screen/useIsSmallScreen';
import { Link } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';



const Footer = () => {
	const { t } = useTranslation('web');

	const isSmallScreen = useIsSmallScreen();

	return (
		<div className='app-footer'>

			{!isSmallScreen &&
				<div className='footer-section about-us-section'>
					<h3>{t('layouts.footer.aboutHeader')}</h3>
					<About />
				</div>}

			{!isSmallScreen &&
				<div className='footer-section about-order-section'>
					<h3>{t('layouts.footer.orderHeader')}</h3>
					<Order />
				</div>}
			
			
			<div className='footer-section map-section'>
				<h3>{t('layouts.footer.mapHeader')}</h3>
				<Link to={NavigateRoutesEnum.salesNetwork} className='disable-selection'>
					<img src={salesNetworkMap} alt='sales network map' />
				</Link>
			</div>

			
			{isSmallScreen &&
				<Collapsible label={t('layouts.footer.aboutHeader')} className='about-us-section'>
					<About />
				</Collapsible>}

			{isSmallScreen &&
				<Collapsible label={t('layouts.footer.orderHeader')} className='about-order-section'>
					<Order />
				</Collapsible>}

			<div className='rounded-logo-wrapper'>
				<img src={logoRounded} alt='footer-logo-rounded' />
			</div>
			
		</div>
	);
}

export default Footer;